import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { GameSettingsService } from '../game-settings.service';
import { environment } from '@env/environment';

@Component({
  selector: 'tie-breaker-screen-colors',
  templateUrl: './tie-breaker-screen-colors.component.html',
  styleUrls: ['./tie-breaker-screen-colors.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TieBreakerScreenColorsComponent implements OnInit {
  s3BucketUrl = environment.s3BucketUrl;

  @Input() color1: string;
  @Input() color2: string;
  @Input() assetsData: any;
  @Input() menuArt: string;
  @Input() drawDate: any;

  constructor(public _gameSettingsService: GameSettingsService) { }

  ngOnInit() {
  }

  get tieBreakerColorWheelData(): any[] {
    const data = this._gameSettingsService.tieBreakerColorWheel.data;
    return Array.isArray(data) ? data : [data];
  }

  get previewData(): any {
    return this.assetsData;
  }

  updateColor(index: number, newColor: string): void {
    this._gameSettingsService.tieBreakerColorWheel.data[index].color = newColor;
  }
}
